import { userFields } from '@openx/components-administration/lib/constants.ts';
import type { UserData } from '@openx/components-administration/lib/utils/context/UserHookTypes.ts';
import type { UserFormData } from '@openx/components-administration/types.ts';

export const transformDataToMatchUserForm = (data: UserData): UserFormData => {
  const { account, email_address, first_name, last_name, role } = data;

  return {
    [userFields.FIRST_NAME]: first_name,
    [userFields.LAST_NAME]: last_name,
    [userFields.EMAIL]: email_address,
    [userFields.ACCOUNT]: account?.id || '',
    [userFields.ROLE]: [role],
  };
};
